const googleConfig = {
  accessKeyId: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
};
console.log(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
export default googleConfig;
